import StarFullSvg  from '../../assests/star-filled.svg';
import StarHalfSvg  from '../../assests/star-half-lined.svg';
import StarEmptySvg from '../../assests/star-lined.svg';

const starStyle = {
  height: '50px'
};

export function Star(){      return <img src={StarFullSvg } style={starStyle} alt="full star"  />; }
export function StarHalf(){  return <img src={StarHalfSvg } style={starStyle} alt="half star"  />; }
export function StarEmpty(){ return <img src={StarEmptySvg} style={starStyle} alt="empty star" />; }

function getNumberOfFullStars(starCount){
  return Math.floor(starCount);
}

function getNumberOfHalfStars(starCount){
  return Math.floor(starCount) === starCount - .5 ? 1 : 0;
}

function generateStars(starCount){

  let result = [ <StarEmpty/>, <StarEmpty/>, <StarEmpty/>, <StarEmpty/>, <StarEmpty/> ];

  if( starCount <= 0 ) return result;

  const fullStars = getNumberOfFullStars(starCount);
  const halfStar =  getNumberOfHalfStars(starCount);
  
  result.fill( <Star/>, 0, fullStars );
  
  if( halfStar ){
    result.fill( <StarHalf/>, fullStars, fullStars + 1);
  }

  return result;
}

export function Stars({ starCount }){
  if(!starCount) return null;
  return (
    <>
      { generateStars(starCount) }
    </>
  );
}